/* eslint-disable */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as relatorioActions from '../actions/relatorioActions'
import $ from 'jquery';

class IndicadorTempoRespostaFaixa extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        if (!$.isEmptyObject(this.props.parametrosPesquisaRelatorio)) {
            
            this.props.actions.IndicadorTempoRespostaPorFaixa(this.props.parametrosPesquisaRelatorio).catch(error => {
                this.alerta('Erro em relatório', error, 'error', 'tc');
            });
            //console.log(' componentDidMount - IndicadorTempoRespostaPorFaixa ', this.props.parametrosPesquisaRelatorio);
        }
    }
    alerta(titulo, mensagem, tipo, posicao) {
        
        // this.props.actionsAlerta.apresentarAlerta({
        //     title: titulo !== null ? titulo : 'Aviso!',
        //     message: mensagem !== null ? mensagem : '',
        //     level: tipo !== null ? tipo : 'error',
        //     position: posicao !== null ? posicao : 'tc',
        //     showMsg: true,
        //     autoDismiss: 25
        // });
    }


    componentWillReceiveProps(nextProps) {
        
        if (!$.isEmptyObject(nextProps.parametrosPesquisaRelatorio)) {
            ;
            if (this.props.parametrosPesquisaRelatorio !== nextProps.parametrosPesquisaRelatorio) {
                this.props.actions.IndicadorTempoRespostaPorFaixa(nextProps.parametrosPesquisaRelatorio).catch(error => {
                    this.alerta('Erro em relatório', error, 'error', 'tc');
                });
                //console.log('manifestações table ', objPesquisa);
            }
        }
    }  

    render() {


        if ($.isEmptyObject(this.props.relatorio) || $.isEmptyObject(this.props.relatorio.dado)) {
            return <div></div>
        }


        if (!$.isEmptyObject(this.props.relatorio)) {

            

            var valor = this.props.relatorio.dado.mValor;

        }
        return (
            <div className="col-lg-4 col-md-4 col-xs-4 centerRow">
                    <div className="overviewCard">
                        <div className="overviewCard-icon overviewCard-icon--document">
                            <i className="fa fa-clock-o fa-2x"></i>
                        </div>
                        <div className="overviewCard-description">
                            <h3 className="overviewCard-title text-light"><strong>{valor}</strong></h3>
                            <p className="overviewCard-subtitle">Tempo médio de atendimento em dias</p>
                        </div>
                    </div>
                </div>

        );
    }
}
IndicadorTempoRespostaFaixa.protoType = {
    actions: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps) {
    
    return {
        relatorio: state.relatorioIndicadorTempoRespostaFaixa
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(relatorioActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(IndicadorTempoRespostaFaixa);


/** WEBPACK FOOTER **
 ** ./src/components/relatorios/IndicadorTempoRespostaFaixa.js
 **/